import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Steps } from "../../components";
import CartInfoFillout from "./components/CartInfoFillout";
import ShopCart from "./components/ShopCart";
import "./style.scss";

const Cart = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(1);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const next = (selectedIds: number[]) => {
    setSelectedProductIds(selectedIds);
    setCurrent(current + 1);
  };
  const element = document.getElementById("cart");
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }

  const steps = [
    {
      index: 1,
      title: t("cart.confirmQty"),
      content: t("cart.confirmQty"),
    },
    {
      index: 2,
      title: t("cart.fillInfo"),
      content: t("cart.fillInfo"),
    },
    {
      index: 3,
      title: t("cart.paymentDone"),
      content: t("cart.paymentDone"),
    },
  ];

  const items = steps.map((item) => ({ key: item.index, title: item.title }));

  const renderForm = () => {
    switch (current) {
      case 1:
        return <ShopCart next={next} />;
      case 2:
        return <CartInfoFillout selectedProductIds={selectedProductIds} />;
      default:
        return <ShopCart next={next} />;
    }
  };

  return (
    <div className="Cart-container" id="cart">
      <div>
        <div>
          <Steps current={current} items={items} />
        </div>
        {renderForm()}
      </div>
    </div>
  );
};

export default Cart;
